import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { handleExport } from '../../../../helpers/export'
import portfolioScoreService from '../../core/service'

export const getTrendByPortfolioCreditRisk = createAsyncThunk(
  'portfolioInsights/score/topCompanies/getTrendByPortfolioCreditRisk',
  async (params, { rejectWithValue }) => {
    try {
      const res = await portfolioScoreService.getTrendByPortfolioCreditRisk(
        params,
      )
      if (res.success) {
        return res.data
      }
      return rejectWithValue({ loading: false })
    } catch (err) {
      if (axios.isCancel(err)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getTrendByPortfolioPerformanceScore = createAsyncThunk(
  'portfolioInsights/score/topCompanies/getTrendByPortfolioPerformanceScore',
  async (params, { rejectWithValue }) => {
    try {
      const res =
        await portfolioScoreService.getTrendByPortfolioPerformanceScore(params)
      if (res.success) {
        return res.data
      }
      return rejectWithValue({ loading: false })
    } catch (err) {
      if (axios.isCancel(err)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const exportTrendByPortfolioCreditRiskScore = createAsyncThunk(
  'portfolioInsights/score/exportTrendByPortfolioCreditRiskScore',
  async (params) => {
    const response =
      await portfolioScoreService.exportTrendByPortfolioCreditRiskScore(params)
    handleExport(response.data, response.filename)
  },
)

export const exportTrendByPortfolioPerformanceScore = createAsyncThunk(
  'portfolioInsights/score/exportTrendByPortfolioPerformanceScore',
  async (params) => {
    const response =
      await portfolioScoreService.exportTrendByPortfolioPerformanceScore(params)
    handleExport(response.data, response.filename)
  },
)
